import { Component, inject } from '@angular/core';
import { IonContent, IonMenu } from "@ionic/angular/standalone";
import { Router } from "@angular/router";
import { MenuController } from "@ionic/angular/standalone";

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonMenu
  ]
})
export class SideMenuComponent {
  private router = inject(Router);
  private menuCtrl = inject(MenuController);

  async navigateTo(page: string) {
    await this.menuCtrl.close('side');
    this.router.navigate([page]);
  }

  async openSocialInNavigator(platform: 'facebook' | 'instagram' | 'tiktok') {
    const urls = {
      facebook: 'https://www.facebook.com/Story.sfax/',
      instagram: 'https://www.instagram.com/story.sfax/',
      tiktok: 'https://www.tiktok.com/@story.sfax'
    };

    window.open(urls[platform], '_blank');
  }
}
